
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/duplicate/[id]",
      function () {
        return require("private-next-pages/duplicate/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/duplicate/[id]"])
      });
    }
  